export function nameOf<T extends object>(nameExtractor: (obj: T) => any): keyof T { // eslint-disable-line
  const proxy = new Proxy({} as T, {
    get(target, prop: string | symbol) {
      return prop
    }
  })

  return nameExtractor(proxy)
}